import TaxPayerApiKeyCrud from "../components/taxpayer-api-key/TaxPayerApiKeyCrud";

const TaxPayerApiKeysPage = () => {
  return (
    <>
      <TaxPayerApiKeyCrud />
    </>
  );
};

export default TaxPayerApiKeysPage;
